import _ from 'lodash'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types/RootState'
import companySelectors from '../company/selectors'
import config from '../../../config'
import { imageDimensions } from '../../../constants/imageDimensions'

class TemplateSelectors {
  getTemplate = (state: RootState) => state.template.template
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.template.status === 'initial' || state.template.status === 'loading'
          : state.template.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  private getTemplateId = createSelector([this.getTemplate], template => template?.id || null)
  getTemplateVersion = createSelector([this.getTemplate], template => template?.version || null)
  getTemplateImageUrl = createSelector(
    [companySelectors.getCompanyId, this.getTemplateId, this.getTemplateVersion],
    (companyId, templateId, templateVersion) => {
      if (templateId === null || templateVersion === null) {
        return null
      }
      return `${config.imgixBaseUrl}templates/${companyId}/${templateId}_${templateVersion}.pdf?page=1&fm=png&auto=format&fit=max&w=${imageDimensions.width}&h=${imageDimensions.height}`
    },
  )
  getInitial = (state: RootState) => state.template.status === 'initial'
  getHasError = (state: RootState) => state.template.status === 'failed'
  getError = (state: RootState) => state.template.error
}

export default new TemplateSelectors()
